export const ROUTES = {
  ticket: '/ticket/:ticketId(\\d+)/:threadId(\\d+)?',
  details: '/details',
  new: '/new',
  root: '/'
};